package com.eladfinish.bible.contest.features.review

/** A point where the user just got value out of the app. */
enum class ReviewMoment(val analyticsName: String) {
    QUIZ(analyticsName = "quiz"),
    PAIR_MATCHING(analyticsName = "pair_matching"),
    PYRAMID(analyticsName = "pyramid"),
    SEARCH(analyticsName = "search"),
}
